import { z } from 'zod'

export const WINBACK_TABS = ['setup', 'runs', 'results'] as const
export const WinbackTabSchema = z.enum(WINBACK_TABS)
export type WinbackTab = z.infer<typeof WinbackTabSchema>

export const DEFAULT_WINBACK_TAB: WinbackTab = 'setup'

export const ChurnWinbackSearchSchema = z.object({
  tab: WinbackTabSchema.optional().catch(undefined),
})
export type ChurnWinbackSearch = z.infer<typeof ChurnWinbackSearchSchema>
